(function () {
  function initCarousel(root) {
    var track = root.querySelector('[data-af-track]');
    var slides = root.querySelectorAll('[data-af-slide]');
    var dots = root.querySelectorAll('[data-af-dot]');
    var prev = root.querySelector('[data-af-prev]');
    var next = root.querySelector('[data-af-next]');
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.speed, 10) || 6000;
    var index = 0;
    var timer = null;

    if (!track || slides.length < 2) return;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (dot, n) {
        dot.classList.toggle('af-hero__dot--on', n === index);
      });
    }

    function start() {
      stop();
      if (!autoplay) return;
      timer = setInterval(function () { goTo(index + 1); }, speed);
    }

    function stop() {
      if (timer) clearInterval(timer);
    }

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); start(); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); start(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.afDot, 10));
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    var x0 = 0;
    root.addEventListener('touchstart', function (e) {
      x0 = e.changedTouches[0].screenX;
      stop();
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var d = x0 - e.changedTouches[0].screenX;
      if (Math.abs(d) > 50) goTo(d > 0 ? index + 1 : index - 1);
      start();
    }, { passive: true });

    goTo(0);
    start();
  }

  function boot() {
    document.querySelectorAll('[data-af-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-af-carousel]');
    if (el) initCarousel(el);
  });
})();
